module.exports = __webpack_public_path__ + "a42483488da9c28123c06778e959728c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/mastercard_2021_chart.png
// module id = 1692
// module chunks = 0